import TagManager from 'react-gtm-module';
import config from '../../config/config';

function setUpGTM() {

    if(!config.gtmId)
        return ;
    const tagManagerArgs = {
        gtmId: config.gtmId
    }
         
    TagManager.initialize(tagManagerArgs);
}


setUpGTM();